'use client';
import { useEffect } from 'react';
import { Button } from 'primereact/button';
import { logError } from '@/lib/errorLogger';

export default function Error({ error, reset }) {
    useEffect(() => {
        logError({
            message: error?.message ?? 'Page error',
            stack:   error?.stack,
            source:  'app/error.js',
            method:  'Error boundary',
        });
    }, [error]);

    return (
        <div
            className="flex flex-column align-items-center justify-content-center gap-4"
            style={{ minHeight: '60vh', padding: '2rem' }}
        >
            <div
                className="flex align-items-center justify-content-center border-round-xl"
                style={{ width: '5rem', height: '5rem', background: '#fef2f2', border: '2px solid #fca5a5' }}
            >
                <i className="pi pi-exclamation-triangle" style={{ fontSize: '2rem', color: '#dc2626' }} />
            </div>

            <div className="flex flex-column align-items-center gap-2 text-center">
                <span className="font-bold text-900 text-xl">Something went wrong</span>
                <span className="text-600 text-sm" style={{ maxWidth: '22rem' }}>
                    An unexpected error occurred. Our team has been notified.
                </span>
            </div>

            <div className="flex gap-2 flex-wrap justify-content-center">
                <Button
                    label="Try again"
                    icon="pi pi-refresh"
                    onClick={reset}
                    className="border-0 text-white font-medium"
                    style={{ background: '#1bb8a7' }}
                    size="small"
                />
                <Button
                    label="Go to Home"
                    icon="pi pi-home"
                    onClick={() => { window.location.href = '/'; }}
                    className="p-button-outlined p-button-sm font-medium"
                    style={{ borderColor: '#d1d5db', color: '#374151' }}
                    size="small"
                />
            </div>
        </div>
    );
}
